import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow,
  TableCell
} from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';

import { convertToDateFormat } from '@/helpers/dateHelpers';

import { useLocations } from '@/data/location';

const LocationsTable = () => {
  const locations = useLocations();
  const navigate = useNavigate();

  const handleRowClick = (locationId) => {
    navigate(`/location/${locationId}`);
  };

  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Region</TableHead>
              <TableHead>Activities</TableHead>
              <TableHead>Created</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {locations.data.map((location) => (
              <TableRow
                key={location.id}
                onClick={() => handleRowClick(location.id)}
                className="cursor-pointer hover:bg-muted"
              >
                <TableCell>{location.name}</TableCell>
                <TableCell>{location.region.name}</TableCell>
                <TableCell>
                  {location.activities.map((activity) => (
                    <Badge key={activity.id} variant="outline" className="mr-1">
                      {activity.activity.title}
                    </Badge>
                  ))}
                </TableCell>
                <TableCell>{convertToDateFormat(location.createdAt)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {locations.data.length}
        </span>
      </div>
    </>
  );
};

export default LocationsTable;
